import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=152eb6ed&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=152eb6ed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152eb6ed",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('152eb6ed')) {
      api.createRecord('152eb6ed', component.options)
    } else {
      api.reload('152eb6ed', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=152eb6ed&scoped=true&", function () {
      api.rerender('152eb6ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2lEcC2vEBvGyG/JS/teamMember.vue"
export default component.exports